export const PROPERTY_REDIRECT_TAB_TARGETS: Record<string, string> = {
  members: "/app/members",
  administrators: "/app/team",
  financials: "/app/financials",
  supplies: "/app/supplies",
};

/**
 * All tabs on the property detail page that navigate away to a standalone
 * route rather than rendering an in-page tab panel.  Includes every key of
 * PROPERTY_REDIRECT_TAB_TARGETS plus `furnishing`, which uses a distinct URL
 * pattern (/app/properties/:id/furnishing) and therefore cannot be in the
 * targets map but must still be excluded from `?tab=` URL-sync.
 */
export const PROPERTY_REDIRECT_ONLY_TABS: ReadonlySet<string> = new Set([
  ...Object.keys(PROPERTY_REDIRECT_TAB_TARGETS),
  "furnishing",
]);
